var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddPage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "add_page_svg__linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 168.2,
    y1: 215,
    x2: 257.48,
    y2: 215,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "add_page_svg__linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 174.2,
    y1: 215,
    x2: 251.48,
    y2: 215,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "add_page_svg__surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%, 96.862745%, 96.862745%)",
      fillOpacity: 1
    },
    d: "M 4.628906 25.492188 C 4.132812 25.492188 3.734375 25.09375 3.734375 24.601562 L 3.734375 7.398438 C 3.734375 6.90625 4.132812 6.507812 4.628906 6.507812 L 27.371094 6.507812 C 27.867188 6.507812 28.265625 6.90625 28.265625 7.398438 L 28.265625 24.601562 C 28.265625 25.09375 27.867188 25.492188 27.371094 25.492188 Z M 26.480469 23.707031 L 26.480469 8.292969 L 5.519531 8.292969 L 5.519531 23.707031 Z M 26.480469 23.707031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%, 96.862745%, 96.862745%)",
      fillOpacity: 1
    },
    d: "M 27.371094 25.046875 L 4.628906 25.046875 C 4.382812 25.046875 4.179688 24.847656 4.179688 24.601562 L 4.179688 7.398438 C 4.179688 7.152344 4.382812 6.953125 4.628906 6.953125 L 27.371094 6.953125 C 27.617188 6.953125 27.820312 7.152344 27.820312 7.398438 L 27.820312 24.601562 C 27.820312 24.847656 27.617188 25.046875 27.371094 25.046875 Z M 5.074219 24.152344 L 26.925781 24.152344 L 26.925781 7.847656 L 5.074219 7.847656 Z M 5.074219 24.152344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#add_page_svg__linear0)"
    },
    d: "M 15.839844 19.320312 C 15.347656 19.320312 14.945312 18.921875 14.945312 18.429688 L 14.945312 16.894531 L 13.410156 16.894531 C 12.917969 16.894531 12.515625 16.492188 12.515625 16 C 12.515625 15.507812 12.917969 15.105469 13.410156 15.105469 L 14.945312 15.105469 L 14.945312 13.570312 C 14.945312 13.078125 15.347656 12.679688 15.839844 12.679688 C 16.332031 12.679688 16.730469 13.078125 16.730469 13.570312 L 16.730469 15.105469 L 18.269531 15.105469 C 18.761719 15.105469 19.160156 15.507812 19.160156 16 C 19.160156 16.492188 18.761719 16.894531 18.269531 16.894531 L 16.730469 16.894531 L 16.730469 18.429688 C 16.730469 18.921875 16.332031 19.320312 15.839844 19.320312 Z M 15.839844 19.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#add_page_svg__linear1)"
    },
    d: "M 15.839844 18.875 C 15.59375 18.875 15.394531 18.675781 15.394531 18.429688 L 15.394531 16.445312 L 13.410156 16.445312 C 13.164062 16.445312 12.964844 16.246094 12.964844 16 C 12.964844 15.753906 13.164062 15.554688 13.410156 15.554688 L 15.394531 15.554688 L 15.394531 13.570312 C 15.394531 13.324219 15.59375 13.125 15.839844 13.125 C 16.085938 13.125 16.285156 13.324219 16.285156 13.570312 L 16.285156 15.554688 L 18.269531 15.554688 C 18.515625 15.554688 18.714844 15.753906 18.714844 16 C 18.714844 16.246094 18.515625 16.445312 18.269531 16.445312 L 16.285156 16.445312 L 16.285156 18.429688 C 16.285156 18.675781 16.085938 18.875 15.839844 18.875 Z M 15.839844 18.875 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPage);
export default __webpack_public_path__ + "static/media/add_page.a6495ee5db435a2a81b419d6312b7b65.svg";
export { ForwardRef as ReactComponent };